import template from 'privacy/opt-out.j2';

import { fireGATrackingEvent } from '@core/js/utils/analyticsUtils';
import { generate, templateLocationExists } from '@core/js/utils/componentUtils';
import { mDom, mDomMaintainInputVals } from '@core/js/utils/renderUtils';
import { requestOptOutSaga } from '@core/js/sagas/privacyPreferencesSagas';

/**
 * Attach component events to DOM
 * @param {object} store The redux store
 * @returns {undefined}
 */
export function attachEvents(store) {
    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-privacy-opt-out'), (e) => {
        const state = store.getState();

        e.preventDefault();
        this.attachLoader(store);
        fireGATrackingEvent(store, 'opt out submit', '');
        store.runSaga(requestOptOutSaga, state);
    });
}

function firstRender(store) {
    this.render(store, this);
}

/**
 * Bootstrap the component onto the page
 * @param {object} store The redux store
 * @param {object} overrides Component-level overrides config
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-privacy-opt-out',
        name: 'privacyOptOutComponent',
        watch: ['core.loggedIn', 'core.privacyRestriction'],
        attachEvents: attachEvents,
        firstRender: firstRender,
        template: template,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals,
        isComponentValid: templateLocationExists,
        loader: {}
    };

    return generate(config, store, overrides);
}
